// extracted by mini-css-extract-plugin
module.exports = {"operator-label":"operator-label-2izh4","operator-label-disabled":"operator-label-disabled-1X9wP","operator-divider":"operator-divider-1Nk1l"};